import { Link } from "react-router-dom";
import { Twitter, Linkedin, Github, Mail } from "lucide-react";
import SynqLogo from "../SynqLogo";

const YEAR = new Date().getFullYear();

const FOOTER_COLS = [
  {
    title: "Products",
    links: [
      { to: "/products/projects", label: "SYNQ Projects" },
      { to: "/products/evolve",   label: "SYNQ Evolve" },
      { to: "/products",          label: "All Products" },
      { to: "/pricing",           label: "Pricing" },
    ],
  },
  {
    title: "Solutions",
    links: [
      { to: "/solutions#enterprise", label: "Enterprise" },
      { to: "/solutions#startups",   label: "Startups" },
      { to: "/solutions#agencies",   label: "Agencies" },
      { to: "/solutions#government", label: "Government" },
    ],
  },
  {
    title: "Resources",
    links: [
      { to: "/resources#guides",  label: "Guides" },
      { to: "/resources#insight", label: "Intelligence Insights" },
      { to: "/resources#docs",    label: "Docs" },
      { to: "/resources#change",  label: "Changelog" },
    ],
  },
  {
    title: "Company",
    links: [
      { to: "/about",   label: "About SYNQ" },
      { to: "/contact", label: "Contact" },
      { to: "/contact?intent=demo", label: "Request Demo" },
      { to: "/legal/privacy", label: "Privacy" },
      { to: "/legal/terms",   label: "Terms" },
    ],
  },
];

export default function MarketingFooter() {
  return (
    <footer data-testid="marketing-footer" className="mt-24 border-t border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-950">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-10">
          {/* Brand block */}
          <div className="col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <SynqLogo size={40} />
              <div>
                <div className="font-outfit font-black text-slate-900 dark:text-white text-lg leading-none">SYNQ</div>
                <div className="text-[10px] font-ibm-plex uppercase tracking-widest text-slate-500 dark:text-slate-500 mt-0.5">
                  Intelligence Platform
                </div>
              </div>
            </div>
            <p className="font-ibm-plex text-sm text-slate-600 dark:text-slate-400 max-w-xs leading-relaxed">
              The Intelligence Platform for modern organizations. Understand, improve, and evolve — with intelligence, not dashboards.
            </p>
            <div className="mt-5 flex items-center gap-2">
              {[
                { Icon: Linkedin, href: "https://linkedin.com" },
                { Icon: Twitter,  href: "https://twitter.com"  },
                { Icon: Github,   href: "https://github.com"   },
                { Icon: Mail,     href: "mailto:hello@synqorg.com" },
              ].map(({ Icon, href }, i) => (
                <a key={i} href={href} target="_blank" rel="noreferrer"
                   className="w-9 h-9 rounded-full border border-slate-200 dark:border-slate-800 flex items-center justify-center text-slate-500 hover:text-slate-900 dark:hover:text-white transition-colors">
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          {FOOTER_COLS.map((col) => (
            <div key={col.title}>
              <div className="font-outfit text-xs font-bold uppercase tracking-widest text-slate-900 dark:text-white mb-4">
                {col.title}
              </div>
              <ul className="space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.to + l.label}>
                    <Link to={l.to} className="font-ibm-plex text-sm text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white transition-colors">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-slate-200 dark:border-slate-800 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="font-ibm-plex text-xs text-slate-500 dark:text-slate-500">
            © {YEAR} <span className="font-semibold text-slate-700 dark:text-slate-300">RamRath Global (GA)</span>. All Rights Reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}
